/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Empty_This_MonthInputs */

const vi_order_empty_this_month = /** @type {(inputs: Order_Empty_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tháng này chưa có đơn nào khớp bộ lọc`)
};

/**

* @param {Order_Empty_This_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_empty_this_month = /** @type {((inputs?: Order_Empty_This_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Empty_This_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_empty_this_month(inputs)
});